import React from "react";

export default function TermsAndConditions() {
  return (
    <div
      style={{
        padding: "24px",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.7",
        background: "linear-gradient(135deg, #fff8f0, #fdfdfd)",
        color: "#2c2c2c",
        borderRadius: "14px",
        maxWidth: "950px",
        margin: "24px auto",
        boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          color: "#b76e79",
          marginBottom: "20px",
        }}
      >
        Terms & Conditions
      </h2>

      <p>
        Welcome to <strong>Toshni Jewellers</strong> (https://toshnijewellers.com).
        These Terms & Conditions govern your use of our website and the purchase
        of products from Toshni Jewellers. By accessing or using this website,
        placing an order, or using our services, you agree to be bound by these
        Terms.
      </p>

      <h3 style={{ color: "#8b5e3c" }}>1. Products & Descriptions</h3>
      <p>
        We strive to provide accurate product descriptions, images and pricing.
        Images are for illustration purposes only. Actual jewellery may vary
        slightly in colour, size or finish. All weights, dimensions and gemstone
        details are approximate unless stated otherwise.
      </p>

      <h3 style={{ color: "#8b5e3c" }}>2. Authenticity & Hallmark</h3>
      <p>
        All gold and silver jewellery sold by Toshni Jewellers is genuine and
        hallmarked or certified as per applicable Indian laws. Diamond and
        gemstone certifications, where applicable, will be provided with the
        product.
      </p>

      <h3 style={{ color: "#8b5e3c" }}>3. Pricing & Payments</h3>
      <p>
        Prices are listed in Indian Rupees (INR). Prices, offers and promotions
        may change without prior notice. Full payment must be made at checkout
        using the payment options available on the website.
      </p>

      <h3 style={{ color: "#8b5e3c" }}>4. Orders, Acceptance & Cancellation</h3>
      <p>
        Orders placed constitute an offer to purchase and are subject to
        acceptance and availability. Toshni Jewellers reserves the right to
        cancel or refuse orders due to stock unavailability, pricing errors,
        suspected fraud or incorrect information.
      </p>

      <h3 style={{ color: "#8b5e3c" }}>5. Custom Orders</h3>
      <p>
        Custom or made-to-order jewellery requires advance payment and may have
        longer delivery timelines. Once production begins, custom orders are
        non-refundable.
      </p>

      <h3 style={{ color: "#8b5e3c" }}>6. Returns & Exchanges</h3>
      <p>
        Returns and exchanges are governed by our Returns Policy available on
        the website. Certain items may not be eligible for return due to hygiene
        or customization. All returned items must be unused and accompanied by
        original packaging and certificates.
      </p>

      <h3 style={{ color: "#8b5e3c" }}>7. Shipping & Delivery</h3>
      <p>
        Delivery timelines vary based on product type and location. Risk of loss
        passes to the customer upon successful delivery. Customers are advised
        to inspect packages at delivery.
      </p>

      <h3 style={{ color: "#8b5e3c" }}>8. Warranty & Repairs</h3>
      <p>
        Some jewellery items may carry manufacturer warranties. Repair services
        may be provided on request, subject to inspection and applicable
        charges.
      </p>

      <h3 style={{ color: "#8b5e3c" }}>9. Intellectual Property</h3>
      <p>
        All website content including images, text, logos and designs is the
        intellectual property of Toshni Jewellers and may not be used without
        prior written consent.
      </p>

      <h3 style={{ color: "#8b5e3c" }}>10. User Responsibilities</h3>
      <p>
        You agree to provide accurate information while placing orders or during
        verification. Misuse, fraud or false information may result in order
        cancellation or account suspension.
      </p>

      <h3 style={{ color: "#8b5e3c" }}>11. Limitation of Liability</h3>
      <p>
        Toshni Jewellers shall not be liable for indirect or consequential
        damages. Total liability shall not exceed the value of the product
        purchased.
      </p>

      <h3 style={{ color: "#8b5e3c" }}>12. Privacy & Data</h3>
      <p>
        Personal data is handled as per our <a href="/privacy-policy">Privacy Policy</a>.
        By using this website, you consent to such processing.
      </p>

      <h3 style={{ color: "#8b5e3c" }}>13. Governing Law & Jurisdiction</h3>
      <p>
        These Terms shall be governed by Indian law. Any disputes shall be
        subject to the exclusive jurisdiction of courts in Jaipur, Rajasthan,
        India.
      </p>

      <h3 style={{ color: "#8b5e3c" }}>14. Contact Information</h3>
      <div
        style={{
          background: "#fff3e6",
          border: "1px solid #f1c27d",
          padding: "16px",
          borderRadius: "10px",
        }}
      >
        <p>
          Phone: <a href="tel:+919352212342">+91 9352212342</a>
          <br />
          Email: <a href="mailto:info@toshnijewellers.com">info@toshnijewellers.com</a>
          <br />
          Address: Rd Number 1, near Murlipura Thana,<n          />
          <strong>Behind Murlipura Thana</strong>, Pravasi Nagar,<br />
          Murlipura, Jaipur, Rajasthan – 302039, India.
        </p>
      </div>

      <p style={{ marginTop: "20px", fontStyle: "italic" }}>
        Last Updated: <strong>{new Date().toLocaleDateString()}</strong>
      </p>
    </div>
  );
}
